var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 14.6673H12.625C12.8021 14.6673 12.9505 14.7272 13.0702 14.8471C13.1901 14.967 13.25 15.1154 13.25 15.2925C13.25 15.4697 13.1901 15.6181 13.0702 15.7377C12.9505 15.8575 12.8021 15.9173 12.625 15.9173H1.375C1.19792 15.9173 1.04951 15.8574 0.929792 15.7375C0.809931 15.6177 0.75 15.4692 0.75 15.2921C0.75 15.1149 0.809931 14.9665 0.929792 14.8469C1.04951 14.7272 1.19792 14.6673 1.375 14.6673ZM6.99208 12.1994C6.87903 12.1994 6.76917 12.1743 6.6625 12.124C6.55583 12.0738 6.46479 11.9986 6.38937 11.8981L2.665 7.04711C2.47806 6.796 2.45347 6.53023 2.59125 6.24982C2.72903 5.9694 2.95451 5.82919 3.26771 5.82919H4.76438V0.837317C4.76438 0.623845 4.8366 0.444957 4.98104 0.300652C5.12535 0.156207 5.30424 0.0839844 5.51771 0.0839844H8.47438C8.68771 0.0839844 8.8666 0.156207 9.01104 0.300652C9.15535 0.444957 9.2275 0.623845 9.2275 0.837317V5.82919H10.7244C11.0374 5.82919 11.2628 5.9694 11.4006 6.24982C11.5384 6.53023 11.5138 6.796 11.3269 7.04711L7.59458 11.8981C7.51931 11.9986 7.42826 12.0738 7.32146 12.124C7.21479 12.1743 7.105 12.1994 6.99208 12.1994Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.cac23a937ecd8448b5beea76795d850b.svg";
export { ForwardRef as ReactComponent };